import { useReduxState } from "SubjectStandardsV2/hooks";
import _ from "lodash";
import {
  getDateMomentObjectCustom,
  checkIsDateSame,
} from "Utils/DateTimeHelpers";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";
import { getRepeatSettingsOrNull } from "../modules/Utils";
import { useRef } from "react";
import { defaultEventDate } from "../../../modules/MyCalendarModule/MyCalendarConstants";

const getEventDetailsSelector = state => {
  return {
    eventModal: _.get(state, "myCalendar.eventModal", ""),
  };
};

const useIsVideoMeetingFormUpdated = (selectedTimeSlot = null) => {
  const { eventModal } = useReduxState(getEventDetailsSelector);
  const {
    eventTitle,
    eventType,
    startDate,
    endDate,
    isRepeatEvent,
    participants,
    description,
    attachments,
    reminders,
    sharedWith,
    entityType,
    entityId,
    repeatEventSettings,
    skipNonOperationalDays,
    meetingLink,
    meetingService,
    thirdPartyMeetingLinkData,
  } = eventModal;
  const { startTime, endTime } = selectedTimeSlot || {};
  const startDateTime = selectedTimeSlot
    ? getDateMomentObjectCustom(
        `${selectedTimeSlot?.startDate} ${startTime}`,
        DATE_TIME_CONSTANTS.YYYY_MM_DD_HH_mm
      )
    : null;
  const endDateTime = selectedTimeSlot
    ? getDateMomentObjectCustom(
        `${selectedTimeSlot?.endDate} ${endTime}`,
        DATE_TIME_CONSTANTS.YYYY_MM_DD_HH_mm
      )
    : null;
  const modalData = {
    eventTitle,
    eventType,
    startDate,
    endDate,
    isRepeatEvent,
    participants,
    location,
    description,
    attachments,
    reminders,
    sharedWith,
    entityType,
    entityId,
    repeatEventSettings: getRepeatSettingsOrNull({
      repeatEventSettings,
      isRepeatEvent,
    }),
    skipNonOperationalDays,
    meetingLink,
    meetingService,
    thirdPartyMeetingLinkData,
  };

  const oldDataRef = useRef({
    ...modalData,
    startDate: startDateTime || startDate,
    endDate: endDateTime || endDate,
  });

  const {
    startDate: previousStartDate,
    endDate: previousEndDate,
  } = oldDataRef.current;
  if (
    checkIsDateSame({
      date1: defaultEventDate,
      date2: previousStartDate,
      check: "millisecond",
    }) &&
    checkIsDateSame({
      date1: defaultEventDate,
      date2: previousEndDate,
      check: "millisecond",
    })
  ) {
    oldDataRef.current.startDate = startDate;
    oldDataRef.current.endDate = endDate;
  }

  if (!oldDataRef.current.entityType) {
    oldDataRef.current.entityType = entityType;
  }
  return !_.isEqual(oldDataRef.current, modalData);
};

export default useIsVideoMeetingFormUpdated;
